export default "__VITE_ASSET__CQOJ7Rqg__"